import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { OnlinePaymentReceipt } from "../state/helpers/OnlinePaymentReceipt"

type OwnProps = {
    pay: OnlinePaymentReceipt,
}

const CreditCardDetails = (props: OwnProps) => {
    const { pay } = props

    return (
        <div className="px-3" style={{ width: "23%" }}>
            <p className="mb-1 border-bottom">
                <small>
                    <FormattedMessage
                        id="payment.payment_method"
                        defaultMessage="Payment method"
                    />
                </small>
            </p>
            {pay.creditCardDetails.attributes.last4 ? (
                <>
                    <pre className="mb-0">
                        {pay.creditCardDetails.attributes.brand.toUpperCase()}
                    </pre>
                    <pre className="mb-0">
                        {pay.creditCardDetails.attributes.cardHolderName}
                    </pre>
                    <pre className="mb-0">
                        **** **** **** {pay.creditCardDetails.attributes.last4}
                    </pre>
                    <pre className="mb-0">
                        {pay.creditCardDetails.attributes.expirationMonth}
                        &nbsp;/&nbsp;
                        {pay.creditCardDetails.attributes.expirationYear}
                    </pre>
                </>
            ) : ("-")}
        </div>
    )
}

export default injectIntl(CreditCardDetails)


// WEBPACK FOOTER //
// ./src/payment/creditcarddetails.component.tsx